import { render, staticRenderFns } from "./BatchReport.vue?vue&type=template&id=5532e1a8&"
import script from "./BatchReport.vue?vue&type=script&lang=js&"
export * from "./BatchReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5532e1a8')) {
      api.createRecord('5532e1a8', component.options)
    } else {
      api.reload('5532e1a8', component.options)
    }
    module.hot.accept("./BatchReport.vue?vue&type=template&id=5532e1a8&", function () {
      api.rerender('5532e1a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/Accounts/BatchReport/BatchReport.vue"
export default component.exports